import { useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { HomeDashboardGrid } from '@/components/home/HomeDashboardGrid';
import { HOME_PATH } from '../home/model';
import { Code, Section } from './Section';
export function HomePatternsSection() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash !== '#home-grid') return;
    let active = true;
    const align = () => {
      if (active)
        document.getElementById('home-grid')?.scrollIntoView({ block: 'start', behavior: 'instant' });
    };
    const frame = requestAnimationFrame(align);
    void document.fonts.ready.then(align);
    return () => {
      active = false;
      cancelAnimationFrame(frame);
    };
  }, [hash]);
  return (
    <Section
      id="home-grid"
      title="Главная: сетка виджетов"
      lead="В настройке виджет можно взять за свободное тело. Соседи сразу показывают место и возвращаются назад, если передумать. Черновик сохраняется по «Готово»."
    >
      <div className="rounded-lg border border-line bg-canvas p-4 sm:p-5">
        <HomeDashboardGrid
          label="Пример личной сетки"
          readOnly
          layout={[
            { id: 'a', column: 0, row: 0, columns: 6, rows: 1 },
            { id: 'b', column: 6, row: 0, columns: 6, rows: 1 },
          ]}
          widgets={[
            {
              id: 'a',
              title: 'Проверки',
              allowedSizes: [{ columns: 6, rows: 1 }],
              content: <p className="type-title">7</p>,
            },
            {
              id: 'b',
              title: 'Завершено',
              allowedSizes: [{ columns: 6, rows: 1 }],
              content: <p className="type-title">24</p>,
            },
          ]}
          onCommit={() => undefined}
        />
        <p className="mt-4">
          <Code>
            HomeDashboardGrid · hoverDelayMs={0} · захват тела · обратимый FLIP · зелёный / коралловый бросок
          </Code>
        </p>
      </div>
      <Link
        to={HOME_PATH + '?board=8'}
        className="inline-flex h-9 items-center gap-2 self-start rounded-md border border-line bg-muted px-3 text-xs font-semibold text-fg hover:bg-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      >
        Открыть Главную
        <ArrowRight className="size-4" />
      </Link>
    </Section>
  );
}
